import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const ImageUploadDraggable = () => {
  const id = v4()
  const type = FormItemType.ImageUpload

  return (
    <FormItemDraggableBase
      icon={IconEnum.Download}
      id={id}
      title="formBuilder.imageUpload"
      type={type}
    />
  )
}
